<script lang="ts">
  import {isShowSearchLoader} from "../../../../stores";
  import Loader from '../../../../custom/Loader.svelte'
</script>

{#if $isShowSearchLoader}
  <div class="flex justify-center">
    <Loader />
  </div>
{/if}